
import './App.css';
import Nav from './menu/Nav'
import Home from './pages/home'

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Product from './pages/Product';
import { Footer } from './pages/Footer';
import Smachine from './pages/products/S_machine';
import { Sealingmachine } from './pages/products/Sealingmachine';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { SealerM } from './pages/products/SealerM';
import { VpM } from './pages/products/VpM';
import { PastefM } from './pages/products/PastefM';
import {ShrinkC} from './pages/products/ShrinkC'
import { PpM } from './pages/products/PpM';
import {Printer} from './pages/products/Printer1'
import { WrappingM } from './pages/products/WrappingM';
import { PetST } from './pages/products/PetST';

function App() {
  return (
    <div className="App">
    
    <Router>
      <Nav />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/Product" element={<Product />} />
        <Route path="/s_machine" element={<Smachine/>} /> 
        <Route path="/Sealingmachine" element={<Sealingmachine/>} />
        <Route path="/SealerMachine" element={<SealerM/>} />
        <Route path="/vacuumpackingM" element={<VpM/>} />
        <Route path="/pastefM" element={<PastefM/>} />
        <Route path="/ShrinkC" element={<ShrinkC/>} />
        <Route path="/ppM" element={<PpM/>} />
        <Route path="/printer" element={<Printer/>} />
        <Route path="/wrappingM" element={<WrappingM/>} />
        <Route path="/PetST" element={<PetST/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/contactus" element={<Contact/>} />

        
      </Routes>
      <Footer/>
    </Router>


    </div>
  );
}
export default App;
